import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SchemaOrg from '@/components/base/SchemaOrg';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import LatestSection from './components/LatestSection';
import PopularSection from './components/PopularSection';
import FaqSection from './components/FaqSection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '蜜桃少年漫画 - 免费阅读无删减漫画下拉式',
          description: '通过178漫画网免费阅读蜜桃少年无删减漫画下拉式版本，轻松下拉浏览全集故事，高清画质让您享受阅读乐趣。',
          url: 'https://sdidsa.cn',
          isPartOf: {
            '@type': 'WebSite',
            name: '蜜桃少年漫画',
            url: 'https://sdidsa.cn',
          },
        }}
      />
      <SchemaOrg
        type="FAQPage"
        data={{
          mainEntity: [
            { '@type': 'Question', name: '蜜桃少年漫画是什么？', acceptedAnswer: { '@type': 'Answer', text: '蜜桃少年漫画是178漫画网旗下的少年向漫画阅读平台，提供海量热血、冒险、搞笑、奇幻等类型漫画，全部免费阅读、无删减、高清画质，支持下拉式流畅阅读体验。' } },
            { '@type': 'Question', name: '漫画多久更新一次？', acceptedAnswer: { '@type': 'Answer', text: '热门连载漫画通常每周更新2-3话，具体更新频率因作品而异。' } },
            { '@type': 'Question', name: '需要注册账号才能阅读吗？', acceptedAnswer: { '@type': 'Answer', text: '不需要！蜜桃少年漫画所有内容完全免费，无需注册即可直接阅读。' } },
            { '@type': 'Question', name: '漫画画质清晰吗？', acceptedAnswer: { '@type': 'Answer', text: '我们提供高清画质的漫画内容，所有漫画均经过专业处理，确保画面清晰锐利。' } },
            { '@type': 'Question', name: '如何找到我想看的漫画？', acceptedAnswer: { '@type': 'Answer', text: '您可以通过首页的分类导航、搜索功能或热门排行来找到感兴趣的漫画。' } },
            { '@type': 'Question', name: '手机可以看漫画吗？', acceptedAnswer: { '@type': 'Answer', text: '当然可以！蜜桃少年漫画完美适配手机、平板和电脑等各类设备。' } },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />

        <main>
          <HeroSection />

          <CategorySection />

          <LatestSection />

          <PopularSection />

          <FaqSection />

          <section className="py-16 md:py-20">
            <div className="w-full px-4 md:px-6 text-center">
              <div className="max-w-2xl mx-auto">
                <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
                  准备好了吗？开始你的漫画之旅
                </h2>
                <p className="text-foreground-500 mb-8 text-sm md:text-base">
                  海量高清漫画，免费下拉式阅读，随时随地享受蜜桃少年漫画带来的快乐
                </p>
                <a
                  href="#latest"
                  className="inline-flex items-center gap-2 px-8 py-3 rounded-lg bg-primary-500 text-background-50 font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                >
                  立即开始阅读 <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>
          </section>
        </main>

        <Footer />
      </div>
    </>
  );
}